module.exports = __webpack_public_path__ + "img/video-icon.fb482481.svg";